// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--v9+KD";
export var buttonUp = "Footer-module--buttonUp--b5Fr-";
export var inner = "Footer-module--inner--0mjyX";
export var iconContainer = "Footer-module--iconContainer--QXT4K";
export var footerItems = "Footer-module--footerItems--lp2iR";
export var column = "Footer-module--column--mCA0g";
export var copyRight = "Footer-module--copyRight--q-DB7";